import { apiClient } from './client'
import type { CalendarEventsResponse, CalendarSummaryResponse } from '../types/calendar'

export const calendarApi = {
  events: (month?: string) =>
    apiClient.get<CalendarEventsResponse>('/api/calendar/events', month ? { month } : undefined),

  summary: () =>
    apiClient.get<CalendarSummaryResponse>('/api/calendar/summary'),
}
